import { DynamicPage, RootState } from "../../../../../models";

export type State = Pick<RootState, "dynamicPages">;
export const getDynamicPages = (state: State): DynamicPage[] => state.dynamicPages || [];
